import { styled, Text } from '@grupoboticario/flora-react';

export default {
  Wrapper: styled('div', {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    padding: '$3 $4',
    width: '100%',
    cursor: 'pointer',
    backgroundColor: '$backgroundAltPrimary',

    button: {
      color: '$backgroundPrimary',
      paddingRight: '$0',
    },

    '@tablet': {
      justifyContent: 'center',

      button: {
        marginLeft: '$1',
      },
    },
  }),

  CurrentStateInfo: styled(Text, {
    width: '100%',
    color: '$backgroundPrimary',

    '@tablet': {
      width: 'auto',
    },
  }),
};
